const styles = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {
      //fontFamily: 'monospace',
    },
    highlighter: {
      padding: 9,
    },
    input: {
      padding: 9,
      border: '1px solid silver',
      borderRadius: '0.25rem',
    }
  },


  '&singleLine': {
    display: 'inline-block',
    width: 180,

    highlighter: {
      padding: 1,
    },
    input: {
      padding: 1,
      borderRadius: '0.25rem',
    },
  },

  suggestions: {
    list: {
      marginTop: '-155px',
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      borderRadius: '3px',
    },
    item: {
      padding: '5px 10px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#f7f7f7',
      },
    },
  },
}
export default styles;
